import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import { Redirect } from 'react-router-dom';

import {
  APIHandler,
  Collection,
  DataHandler,
  VideoCollection,
  ImageCollection,
} from 'C4';
import { storageKeys } from 'settings';

export default class CollectionView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collection: [],
      escaped: false,
    };

    this.onEsc = this.onEsc.bind(this);
  }

  componentWillMount() {
    const { url } = this.props.match;
    document.addEventListener('keydown', this.onEsc);
    DataHandler.matchAppId().then((id) => {
      const appId = id;

      if (url.split('/').slice(-2).includes('antarctic-images')) {
        console.log(url.split('/').slice(-1).pop());
        if (url.split('/').slice(-1).pop() === 'antarctic-images') {
          APIHandler.getCollection(3271)
            .then(res => this.setState({ collection: res.items }));
        } else {
          APIHandler.getCollection(url.split('/').slice(-1).pop())
            .then(res => this.setState({ collection: res.items }));
        }
      } else if (url.split('/').slice(-2).includes('arctic-images')) {
        if (url.split('/').slice(-1).pop() === 'arctic-images') {
          APIHandler.getCollection(3290)
            .then(res => this.setState({ collection: res.items }));
        } else {
          APIHandler.getCollection(url.split('/').slice(-1).pop())
            .then(res => this.setState({ collection: res.items }));
        }
      } else if (url.split('/').slice(-2).includes('brochures')) {
        if (url.split('/').slice(-1).pop() === 'brochures') {
          APIHandler.getNamedCollection('brochures', appId)
            .then(res => this.setState({ collection: res.items }));
        } else {
          APIHandler.getCollection(url.split('/').slice(-1).pop())
            .then(res => this.setState({ collection: res.items }));
        }
      } else if (url.split('/').slice(-2).includes('unique-experiences')) {
        if (url.split('/').slice(-1).pop() === 'unique-experiences') {
          APIHandler.getNamedCollection('unique experiences', appId)
            .then(res => this.setState({ collection: res.items }));
        } else {
          APIHandler.getCollection(url.split('/').slice(-1).pop())
            .then(res => this.setState({ collection: res.items }));
        }
      } else if (url.split('/').slice(-2).includes('social-media')) {
        if (url.split('/').slice(-1).pop() === 'social-media') {
          APIHandler.getNamedCollection('social media', appId)
            .then(res => this.setState({ collection: res.items }));
        } else {
          APIHandler.getCollection(url.split('/').slice(-1).pop())
            .then(res => this.setState({ collection: res.items }));
        }
      } else if (url.split('/').slice(-1).pop() === 'images') {
        DataHandler.checkKey(storageKeys.images, APIHandler.getImages(appId))
          .then(res => this.setState({ collection: res.items }));
      } else if (url.split('/').slice(-1).pop() === 'videos') {
        DataHandler.checkKey(storageKeys.videos, APIHandler.getVideos(appId))
          .then(({ items }) => {
            const newItems = {};
            Object.keys(items).forEach((key) => {
              const [firstItem] = items[key];
              const { chapter: { chapterNumber } } = firstItem;
              newItems[chapterNumber] = items[key];
            });
            this.setState({ collection: newItems });
          });
      } else if (url.split('/').slice(-1).pop() === 'videoLibrary') {
        DataHandler.checkKey(storageKeys.videoLibrary, APIHandler.getVideos(appId))
          .then(({ items }) => {
            const newItems = {};
            Object.keys(items).forEach((key) => {
              const [firstItem] = items[key];
              const { chapter: { chapterNumber } } = firstItem;
              newItems[chapterNumber] = items[key];
            });
            this.setState({ collection: newItems });
          });
      } else {
        APIHandler.getNamedCollection(url.split('/').slice(-1).pop().replace(/-/g, ' ').replace('   ', ' - '), appId)
          .then(res => this.setState({ collection: res.items }));
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.setState({ escaped: true });
    }
  }

  render() {
    const { escaped, collection } = this.state;

    const { url, params } = this.props.match;
    const { videoId } = params;

    const redirPath = (
      videoId !== undefined
        ? url.substring(0, url.lastIndexOf('/')).lastIndexOf('/')
        : url.lastIndexOf('/')
    );

    return (
      <div className="collection__Container">
        <div className="collection__Background--overlay" />

        {url.split('/').slice(-1).pop() === 'videos' &&
          Object.values(collection).map(chapter => (
            <VideoCollection
              key={chapter[0].chapter.chapterNumber}
              chapterCollection={chapter}
            />
          ))}
        {url.split('/').slice(-1).pop() === 'images' &&
          Object.values(collection).map(chapter => (
            <ImageCollection
              key={chapter[0].chapter.chapterNumber}
              chapterCollection={chapter}
            />
          ))}
        {url.split('/').slice(-1).pop() === 'videoLibrary' &&
        Object.values(collection).map(chapterVideos => (
          <VideoCollection
            key={chapterVideos[0].chapter.chapterNumber}
            chapter={chapterVideos}
          />
        ))}

        {url.split('/').slice(-1).pop() === 'image-library' &&
          Object.values(collection).map(col => (
            <div className="brochures">
              <Collection
                key={col[0].pageID}
                content={col}
                header="Image Library"
              />
            </div>
        ))}

        {url.split('/').slice(-1).pop() !== 'images' &&
         url.split('/').slice(-1).pop() !== 'videos' && 
          url.split('/').slice(-1).pop() !== 'image-library' &&
        Object.keys(collection).map(key => (
          <div className={`brochures ${url.split('/').slice(-1).pop()}`} key={url.split('/').slice(-2).pop()}>
            <Collection
              key={collection[key][0].pageID}
              content={collection[key]}
              header={key}
            />
          </div>
          ))}

        {escaped && <Redirect to={url.substring(0, redirPath)} />}
      </div>
    );
  }
}

CollectionView.propTypes = {
  match: PropTypes.shape().isRequired,
};
